import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import Server from "../../Shared/Server";
import { toast } from 'react-toastify'
import Spinner from '../../Shared/Spinner'
import SelectField from "../../Shared/SelectField";
import {years_list, months_list} from "../../Shared/List";
import { InputField } from "../../Shared/InputField";

const SubPayment = (props) => {
    const current_user = JSON.parse(localStorage.getItem('user'))
    const billing_date  = current_user?.branch?.billing_date

    const [errors, setErrors] = useState({});
    const [yearOptions, setYearOptions] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const date = new Date().toISOString().slice(0, 10)

    const navigate = useNavigate()

    const [formData, setFormData] = useState({
        year: billing_date?.year || date.year,
        month: billing_date?.month || date.month,
        book: "",
        page: "",
    })
    const {year, month, book, page} = formData


    useEffect(() => {
        const years = []
        const months = []
        years_list.map(year => (
            years.push({
                id: year.id,
                key: year.key,
                name: year.name
            })
        ))
        
        months_list.map(month => (
            months.push({
                id: month.id,
                key: month.key,
                name: month.name
            })
        ))

        setYearOptions(years)
        setMonthOptions(months)
    }, [])

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()
        
        //find category name with its index
        const payload = {year, month, book}
        getBookVouchers(payload)
        
    }

    const getBookVouchers = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/payments/receipt-number', payload)
            if (response.status === 200){
                payload.page = response.data.page
                if (response.data.vouchers < 50){
                    navigate('/payment', {state: {payload: payload}})
                }else {
                    toast.error(`Book with ${book} is full`)
                }
                setIsLoading(false)
            }else{
                toast.error('unknown error occurred')
            }
        } catch (error) {
            setIsLoading(false)
            if(error?.response?.status === 401){
                navigate('/login')
            }else if (error?.response?.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error('unknown error occurred. please try again')
            }
        }
    }


    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
    
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Sub Payment Form</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <SelectField
                                name="year"
                                label="Year"
                                value={parseInt(year)}
                                options={yearOptions}
                                onChange={onChange}
                                error={errors.year}
                            />
                        </div>
                        <div className="col-md-4">
                            <SelectField
                                name="month"
                                label="Month"
                                value={parseInt(month)}
                                options={monthOptions}
                                onChange={onChange}
                                error={errors.month}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                placeholder="Book Number"
                                name="book"
                                type="text"
                                required="required"
                                label="Book"
                                value={book}
                                onChange={onChange}
                                error={errors.book}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-info mt-2" value="Next" style={{float: 'right'}}/>
                        </div>
                    </div>
                    <br/>
                </form>
            </div>
        </div>
      <br/>
    </>
  )
}

export default SubPayment